<template>
  <div class="pages" :style="{paddingTop: headerFormHeight + 'px'}">
    <header-form 
      ref="headerFormRef" 
      :businessType="businessType" 
      :abnormalData="abnormalData"
      @getHeaderFormHeight="getHeaderFormHeight"
    />
    <excel-table 
      ref="excelTableRef" 
      @tableRowRemove="handleTableRowRemove"
    ></excel-table>
    <div class="footer" v-if="businessType === 'upload'">
      <div 
        class="footer-button warning-button" 
        style="height: 48px;"
        @click="handleUpload"
      >确认上传</div>
    </div>
    <div class="footer" v-else-if="businessType === 'generate'">
      <div 
        class="footer-button warning-plain-button" 
        @click="handleCancel"
      >取消</div>
      <div 
        class="footer-button warning-button" 
        @click="handleGenerate"
      >确认生成</div>
    </div>
    <modal ref="modalRef" />
  </div>
</template>

<script>
import { importMaterialTask , fileUpload , verifyMaterialTask } from "@/api/material/materialDataUpload/index.js"
import { Uploader , Icon , Image as VanImage , Toast } from 'vant';
import headerForm from "./components/header-form.vue";
import excelTable from "./components/excel-table.vue";
import modal from "@/view/material/components/modal.vue";
export default {
  components:{
    [Uploader.name]:Uploader,
    [Icon.name]:Icon,
    [VanImage.name]:VanImage,
    [Toast.name]:Toast,
    headerForm,
    excelTable,
    modal
  },
  data(){
    return {
      businessType: "upload",  // upload(上传类型)  generate(生成类型)
      fileList:[],
      // 前端可回显文件格式
      fileSuffixList:[
        { iconName: "word-icon" , suffixList:["doc","docx"] , width: "36" , height: "40" },
        { iconName: "excel-icon" , suffixList:["xls","xlsx"] , width: "36" , height: "40" },  
        { iconName: "ppt-icon" , suffixList:["ppt","pptx"] , width: "36" , height: "40"},
        { iconName: "pdf-icon" , suffixList:["pdf"] , width: "39" , height: "40" },
        { iconName: "image-icon" , suffixList:["bmp","gif","ico","jpg","png","webp","heic","raw"] , width: "36" , height: "36" },
        { iconName: "video-icon" , suffixList:["mp4","flv","m3u8","rtmp","hls","rtsp","mov"] , width: "36" , height: "36" },
        { iconName: "audio-icon" , suffixList:["mp3"] , width:"33" , height: "40" },
        // { iconName: "unknown-icon" , suffixList:[] , width},
      ],
      // 后端限制文件格式
      backendSuffix:[
        // 图片
        "bmp", "gif", "jpg", "jpeg", "png", "raw",
        // Word Excel powerpoint
        "doc", "docx", "xls", "xlsx", "ppt", "pptx", "html", "htm", "txt", 
        // 压缩文件
        "rar", "zip", "gz", "bz2", 
        // 视频格式
        "mp4", "avi", "rmvb", "mov",
        // pdf
        "pdf"
      ],
      backendSuffixUpperCase:[],
      headerFormHeight: 0,
      fileUploadInfo:{},
      abnormalData: {}
    }
  },
  provide(){
    return {
      getMaterialFile: () => this.$refs.headerFormRef.materialFile,
      getTemplateActive: () => this.$refs.headerFormRef.templateActive,
      tableAbnormalPosition: () => this.$refs.excelTableRef.handleTableAbnormalPosition(),
      tableWarningPosition: () => this.$refs.excelTableRef.handleTableWarningPosition(),
      getTableData: () => this.$refs.excelTableRef.tableData,
      getForm: () => this.$refs.headerFormRef.form,
      modal: options => this.$refs.modalRef.open(options)
    }
  },
  created(){
    // 兼容大写文件后缀
    this.fileSuffixList = this.fileSuffixList.map(fileItem=>({ ...fileItem , suffixList: this.handleToLocaleUpperCase(fileItem.suffixList) }));
    this.backendSuffixUpperCase = this.backendSuffix.map(item=>item.toLocaleUpperCase());
  },
  methods:{
    getHeaderFormHeight(){
      this.headerFormHeight = document.querySelector(".header-form").offsetHeight;
    },
    handleToLocaleUpperCase(list){
      let newList = [];
      list.map(item => {
        newList.push(item);
        newList.push(item.toLocaleUpperCase());
      });
      return newList;
    },
    // 生成领料任务
    async handleGenerate(){
      try {
        let tableData = this.$refs.excelTableRef.tableData;
        let abnormalData = await this.importMaterialTask({ tableData });
        abnormalData = abnormalData || {}
        this.$loading.close();
        if(abnormalData.errorMessageList && abnormalData.errorMessageList.length > 0){
          this.$refs.excelTableRef.handleAbnormalData(abnormalData);
          await this.nextTick();
          this.$refs.excelTableRef.handleTableAbnormalPosition();
          return;
        };
        await this.$dialog.confirm({
          title: "确认生成领料任务",
          message: `本次共计生成${tableData.length}条领料任务，是否确认`,
          className: "confirm-dialog--warning",
        });
        this.$router.replace("/material/materialDataUpload/generatedSuccess");
        return Promise.resolve(abnormalData);
      } catch (error) {
        this.$loading.close();
        return Promise.reject(error);
      }
    },
    // 上传 excel json 数据
    async handleUpload(){
      try {
        // 校验表单
        await this.$refs.headerFormRef.validate();
        // excel 转 json
        this.$loading.open();
        let jsonRes = await this.$refs.excelTableRef.excelFileToJson(this.$refs.headerFormRef.materialFile);
        jsonRes.tableData = jsonRes.tableData.map(rowItem => {
          if(!rowItem.colData || !rowItem.colData.length) return rowItem;
          let colData = rowItem.colData.map(colItem => ({
            ...colItem,
            value: colItem.value && typeof colItem.value === "string" ? colItem.value.trim() : colItem.value
          }));
          return {
            ...rowItem,
            colData
          }
        })
        this.$store.commit("EXCEL_FILE_TO_JSON_DATA",jsonRes);
        await this.fileUpload();
        // 导入领料任务
        let abnormalData = await this.verifyMaterialTask({ tableData: jsonRes.tableData });
        abnormalData = abnormalData || {};
        this.$loading.close();
        if((abnormalData.errorMessageList && abnormalData.errorMessageList.length) || (abnormalData.warningMessageList && abnormalData.warningMessageList.length)) {
          this.setTableData(jsonRes);
          this.$refs.excelTableRef.handleAbnormalData(abnormalData);
          this.businessType = "generate";
          this.$nextTick(() => {
            this.getHeaderFormHeight();
          })
        }else {
          await this.importMaterialTask({ tableData: jsonRes.tableData });
          this.$router.replace("/material/materialDataUpload/generatedSuccess");
        };
        return Promise.resolve(abnormalData);
      } catch (error) {
        console.log("upload error",error);
        this.$loading.close();
        return Promise.reject(error);
      }
    },
    setTableData(jsonData){
      Object.keys(jsonData).forEach(key => {
        this.$refs.excelTableRef[key] = jsonData[key];
      })
    },
    async fileUpload(){
      try {
        let file = this.$refs.headerFormRef.materialFile;
        let formData = new FormData();
        formData.append("file", file);
        formData.append("fileType", "material");
        let { data } = await fileUpload({
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data"
          },
          custom: { closeLoading: false }
        });
        this.fileUploadInfo = data;
        return Promise.resolve(data);
      } catch (error) {
        console.log("上传失败",error);
        return Promise.reject(error);
      }
    },
    async verifyMaterialTask({ tableData }){
      try {
        let headerForm = this.$refs.headerFormRef.form;
        let { data } = await verifyMaterialTask({
          custom: { closeLoading: false },
          data: {
            materialSupplierId: headerForm.materialSupplierId,
            fileImportRecordsId: this.fileUploadInfo.fileId,
            materialOriginalDataVoList: tableData.map(row => {
              let colOptions = row.colData.reduce((obj, colItem) => ({
                ...obj,
                [colItem.keyName]: colItem
              }),{});
              return {
                materialCode: colOptions.materialCode.value,
                issueNumber: colOptions.issueNumber.value,
                issueTime: colOptions.issueTime.value,
                materialWarehouse: colOptions.materialWarehouse.value,
                deliveryLocation: colOptions.deliveryLocation.value,
                workCenter: colOptions.workCenter.value,
                materialType: colOptions.materialType.value,
                materialDescription: colOptions.materialDescription.value,
                remark: colOptions.remark.value
              }
            }),
          },
        });
        /* this.$refs.headerFormRef.tableDataInfo = {
          total: tableData.length,
          errorAbnormal: data.errorMessageList ? data.errorMessageList.length : 0,
          warningAbnormal: data.warningMessageList ? data.warningMessageList.length : 0,
        }; */
        this.abnormalData = this.deepClone({
          ...data,
          total: tableData.length
        });
        return Promise.resolve(data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    // 导入领料任务
    async importMaterialTask({ tableData }){
      try {
        let headerForm = this.$refs.headerFormRef.form;
        let { data } = await importMaterialTask({
          custom: { closeLoading: false },
          data: {
            materialSupplierId: headerForm.materialSupplierId,
            fileImportRecordsId: this.fileUploadInfo.fileId,
            materialOriginalDataVoList: tableData.map(row => {
              let colOptions = row.colData.reduce((obj, colItem) => ({
                ...obj,
                [colItem.keyName]: colItem
              }),{});
              return {
                materialCode: colOptions.materialCode.value,
                issueNumber: colOptions.issueNumber.value,
                issueTime: colOptions.issueTime.value,
                materialWarehouse: colOptions.materialWarehouse.value,
                deliveryLocation: colOptions.deliveryLocation.value,
                workCenter: colOptions.workCenter.value,
                materialType: colOptions.materialType.value,
                materialDescription: colOptions.materialDescription.value,
                remark: colOptions.remark.value,
                tempAdded: headerForm.tempAdded
              }
            }),
          },

        });
        /* this.$refs.headerFormRef.tableDataInfo = {
          total: tableData.length,
          errorAbnormal: data.errorMessageList ? data.errorMessageList.length : 0,
          warningAbnormal: data.warningMessageList ? data.warningMessageList.length : 0,
        }; */
        this.abnormalData = this.deepClone({
          ...data,
          total: tableData.length
        });
        return Promise.resolve(data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    handleCancel(){
      window.uni.navigateBack({ delta: 1 });
    },
    nextTick(){
      return new Promise(resolve => {
        this.$nextTick(() => {
          resolve();
        })
      })
    },
    handleTableRowRemove({ index , tableData }){
      /* if(this.abnormalData.warningMessageList && this.abnormalData.warningMessageList.length) {
        let findIndex = this.abnormalData.warningMessageList.findIndex(findItem => findItem.rawIndex === index);
        ~findIndex && this.abnormalData.warningMessageList.splice(findIndex,1);
      }
      if(this.abnormalData.errorMessageList && this.abnormalData.errorMessageList.length) {
        let findIndex = this.abnormalData.errorMessageList.findIndex(findItem => findItem.rawIndex === index);
        ~findIndex && this.abnormalData.errorMessageList.splice(findIndex,1);
      };
      this.$set(this.abnormalData,"total",tableData.length)
      this.$forceUpdate(); */
    }
  }
}
</script>

<style scoped lang="scss">
  .pages {
    padding: 0 0 200px 0;
    .upload-button {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #EC892E;
      // background: linear-gradient(180deg, #5EB0FF 0%, #EC892E 100%);
      margin-bottom: 16px;
      .add-o {
        margin-right: 8px;
        color: #EC892E;
        font-weight: bold;
      }
    }
    .file-list {
      background-color: #FFF;
      padding: 8px 12px;
      .file-item + .file-item {
        margin-top: 8px;
      }
      .file-item {
        border: 1px solid #EFEFEF;
        padding: 18px 16px 16px 16px;
        overflow: hidden;
        .file-name {
          font-size: 16px;
          line-height: 24px;
          color: #333;
          word-break: break-all;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .file-name-suffix {
          flex-shrink: 0;
          font-size: 16px;
          line-height: 24px;
          color: #333;
        }
        .file-delete {
          font-size: 12px;
          color: #DC3C33;
          line-height: 24px;
          flex-shrink: 0;
          margin-left: 16px;
          flex-shrink: 0;
        }
        .file-size {
          font-size: 12px;
          color: #A6B6C6;
          line-height: 20px;
        }
        .file-upload-time {
          font-size: 12px;
          line-height: 12px;
          color: #A6B6C6;
          margin-top: 16px;
        }
      }
    }
    .footer {
      // height: 96px;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      display: flex;
      justify-content: space-between;
      background-color: #FFF;
      padding: 16px 32px;
      .footer-button + .footer-button {
        margin-left: 67px;
      }
      .footer-button {
        flex: 1;
        min-width: 122px;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF;
        border-radius: 4px;
        border-width: 1px;
        border-style: solid;
        box-sizing: border-box;
      }
      .warning-plain-button {
        background-color: #FFF;
        border-color: #EC892E;
        color: #EC892E;
        &:active {
          background-color: #EC892E;
          color: #FFF;
        }
      }
      .warning-button {
        background-color: #EC892E;
        border-color: #EC892E;
        &:active {
          background-color: rgba(236, 137, 46, .7);
          border-color: rgba(236, 137, 46, .7);
        }
      }
    }
    ::v-deep .van-toast__text {
      height: 46px !important;
    }
  }
</style>

<style lang="scss">
  .material-data-upload-toast {
    line-height: 6px;
    top: 10%;
    max-width: 90%;
    .van-toast__text {
      line-height: 0;
    }
  }
</style>